module.exports = __webpack_public_path__ + "assets/img/1_1545.b2193d66.jpg";